import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import { Tabs, Tab, Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import _omit from 'lodash/omit';

const ScrollableTabsButtonPrevent = ({
  classes,
  defaultActive,
  tabs,
  divider,
  dividerProps,
  sectionProps,
  isFixed,
  tabsClasses,
  isTopPadded,
  ...props
}) => {
  const [activeTab, setActiveTab] = React.useState(defaultActive);
  const onChange = React.useCallback((event, newValue) => setActiveTab(newValue), [setActiveTab]);
  const selectedTab = props.value || activeTab;
  let rootClass;
  if (isFixed) {
    if (isTopPadded) {
      rootClass = classes.appBarRootFixedTopPadded;
    } else {
      rootClass = classes.appBarRootFixed;
    }
  } else {
    rootClass = classes.appBarRoot;
  }

  const tabsProps = _omit(props, ['dispatch']);

  return (
    <AppBar position="static" color="default" classes={{ root: rootClass }}>
      <Tabs
        value={selectedTab}
        onChange={props.onChange ? props.onChange : onChange}
        variant="scrollable"
        scrollButtons="off"
        classes={{
          indicator: classes.indicator,
          scroller: classes.scroller,
          ...tabsClasses,
        }}
        data-testid="tabs"
        {...tabsProps}
      >
        {tabs.map((tab) => (
          <Tab
            label={tab.label}
            aria-label={tab.label}
            data-testid={tab.label}
            key={tab.label || tab.route}
            disabled={tab.disabled}
            classes={{ root: classes.tabRoot }}
          />
        ))}
      </Tabs>
      {divider && <Divider classes={{ root: classes.divider }} {...dividerProps} />}
      {tabs.map(
        (tab, index) =>
          !tab.route && (
            <Box key={tab.label} hidden={index !== selectedTab} {...sectionProps}>
              {tab.content}
            </Box>
          ),
      )}
    </AppBar>
  );
};

ScrollableTabsButtonPrevent.propTypes = {
  classes: PropTypes.shape({}),
  tabsClasses: PropTypes.shape({}),
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
      content: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      disabled: PropTypes.bool,
    }),
  ),
  defaultActive: PropTypes.number,
  divider: PropTypes.bool,
  isFixed: PropTypes.bool,
  dividerProps: PropTypes.shape({}),
  isTopPadded: PropTypes.bool,
};

ScrollableTabsButtonPrevent.defaultProps = {
  classes: {},
  tabsClasses: {},
  tabs: [],
  divider: false,
  isFixed: false,
  defaultActive: 0,
  dividerProps: {},
};

export default ScrollableTabsButtonPrevent;
